<template>
    <Box  @close="close({})" :width="'600px'" style="margin-top: 100px;" :centered="true">
        <template #top>Generar Guía de Remisión Remitente</template>
        <template #center>
            <div class="nj-card">
                <div class="nj-subtitle-1">Conductores</div>
                <div class="nj-cols form">
                    <!-- <Search id="search-conductores" label="Conductores" itemKey="cdt_id" :items="conductores" :labelFunction="setLabel" @search="buscarConductor($event)" @select="seleccionarConductor($event)">
                        <template #default="data">
                            <div style="display: grid; grid-template-columns: 1fr auto;">
                                <span>{{ data.item.cdt_nombre }} {{ data.item.cdt_apellido }} ({{ data.item.cdt_placa }})</span>
                            </div>
                        </template>
                    </Search> -->
                </div>
            </div>
        </template>
        <template #bottom>
            <Button label="Generar" icon="doc" color="green" @click="generarGuia()"></Button>
        </template>
    </Box>
</template>
<script>
import { Confirm } from "../../util"
import { Box, Button, Search } from "../components/"
import { ConductorService, EnvioService, ResponseStatus } from "../../services"
import Toast from "../../util/toast"
export default {
    name: "GenerarGuia",
    components: {
        Box,
        Button,
        Search,
    },
    props: {
        env_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            envio: {
                env_id: this.env_id,
                cdt_id: null
            },
            conductores: []
        }
    },
    methods: {
        setLabel(conductor) {
            return `${conductor.cdt_nombre}  ${conductor.cdt_apellido} (${conductor.cdt_placa})`
        },
        buscarConductor(value) {
            this.conductores = []
            if (value) {
                const request = {
                    conductor: {
                        cdt_search: value,
                        busquedaRapida: true
                    }
                }
                ConductorService.buscar(request)
                    .then(response => {
                        if (ResponseStatus.isSuccess(response)) {
                            this.conductores = response.data
                        }
                        else {
                            Toast.error(response.message)
                        }
                    }).catch(error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    })
            }
            else {
                Toast.error("Debe ingresar alguna referencia del conductor")
                this.conductores = []
            }
        },
        seleccionarConductor(conductor) {
            this.envio.cdt_id = conductor.cdt_id
            this.conductores = []
        },
        generarGuia() {
            Confirm.show({
                message: "¿Desea continuar con la generación de la guía de remisión remitente?",
                action: () => {
                    const request = {
                        envio: this.envio
                    }
                    EnvioService
                        .generarGuiaRemitente(request)
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.close({
                                    renderizar: true
                                })
                            }
                            else {
                                Toast.error(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        })
                }
            })
        },
        close({
            componente = "generarGuia",
            status = false,
            renderizar = false
        }) {
            this.$emit("close", {
                componente,
                status,
                renderizar
            })
        }
    },
    mounted() {

    }
}
</script>

<style scoped></style>